import BoxActionButtons from "@components/BoxActionButtons";
import { PROJECT_DETAIL } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import {
  getProjectFeaturedAsString,
  listingTypeMap,
  projectStatusMap,
  projectTypeMap,
} from "@helpers/project.helper";
import { getCapitalizedFirstChar } from "@helpers/string";
import { IProjectList } from "@interfaces/projectList";
import BanIcon from "mdi-react/BanIcon";

const listProjectMapper = (items: IProjectList[], handleBan: Function) =>
  items.map(
    ({
      uuid,
      name,
      artist,
      projectType,
      listingType,
      network,
      status,
      createdAt,
      banned,
      featured,
    }) => ({
      uuid,
      name,
      artist,
      projectType: projectTypeMap[projectType],
      listingType: listingTypeMap[listingType],
      network: getCapitalizedFirstChar(network),
      status: projectStatusMap[status],
      createdAt: timestampToString(createdAt),
      _createdAtTs: createdAt ?? 0,
      banned: banned ? (
        <span style={{ marginLeft: "25px" }}>
          <BanIcon style={{ width: "1.1rem", fill: "#e01d27" }} />
        </span>
      ) : (
        "-"
      ),
      featured: getProjectFeaturedAsString(featured),
      actions: (
        <BoxActionButtons
          uuid={uuid}
          description={name}
          handleModal={handleBan}
          detailUrl={PROJECT_DETAIL}
          isBanned={banned}
          isProject={true}
        />
      ),
    })
  );

export default listProjectMapper;
